import * as actionTypes from 'constants/ActionTypes';

export function postRequestCargo(cargoRequest) {
    return {
        type: actionTypes.POST_CARGO_REQUEST.REQUEST,
        cargoRequest,
    };
}

export function getRequestsCargo(filter) {
    return {
        type: actionTypes.GET_CARGO_REQUESTS.REQUEST,
        filter,
    };
}

export function updateRequestCargo(cargoRequestId, userId) {
    return {
        type: actionTypes.UPDATE_CARGO_REQUEST.REQUEST,
        cargoRequestId,
        userId,
    };
}

export function deleteRequestCargo(cargoRequestId) {
    return {
        type: actionTypes.DELETE_CARGO_REQUEST.REQUEST,
        cargoRequestId,
    };
}


// WEBPACK FOOTER //
// ./app/actions/cargoes/requests.js